/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FindServiceResponseDto } from '../../models/find-service-response-dto';

export interface EnrollmentScheduleGroupControllerFindServiceByCenterChildIds$Params {
  childIds: Array<string>;
}

export function enrollmentScheduleGroupControllerFindServiceByCenterChildIds(http: HttpClient, rootUrl: string, params: EnrollmentScheduleGroupControllerFindServiceByCenterChildIds$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FindServiceResponseDto>>> {
  const rb = new RequestBuilder(rootUrl, enrollmentScheduleGroupControllerFindServiceByCenterChildIds.PATH, 'get');
  if (params) {
    rb.query('childIds', params.childIds, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FindServiceResponseDto>>;
    })
  );
}

enrollmentScheduleGroupControllerFindServiceByCenterChildIds.PATH = '/api/enrollment-schedule-group/service';
